// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aCIW","controls":"styles_controls__21UGG","charLimit":"styles_charLimit__3wMHI","input":"styles_input__2Fz-f","send":"styles_send__I9_gS"};